module.exports = __webpack_public_path__ + "static/media/11-lightbox-shop.0e10d7cf.png";